import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../../../../../components/Button/Button";
import VfCopilotIcon from "../../../../../../assets/svg/vf-copilot-icon";
import RightArrowIcon from "../../../../../../assets/svg/right-arrow-icon";
import AddIcon from "../../../../../../assets/svg/add-icon";
import CategoryCard from "./components/Category/CategoryCard";
import { KnowledgeBaseCategory, KnowledgeBaseCategoryAPI } from "./utils/types";
import ManageDocumentsTable from "./components/ManageDocumentsTable/ManageDocumentsTable";
import CategoryDetailView from "./components/Category/CategoryDetailView";
import AddContentDrawer from "./components/AddContentDrawer/AddContentDrawer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetKnowledgeBaseCategoriesQuery } from "../../../../../../redux/services/helpdeskApi";
import { getCategoryIcon } from "./utils/categoryIcons";
import FileManagement from "./FileManagement/FileManagement";
import { RootState } from "../../../../../../redux/store";
import { getRegionLabel } from "../../../../../../utils/constants/mappings";

const KnowledgeBase = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const clientCode = useSelector(
    (state: RootState) => state?.auth?.client?.client_code
  );
  const knowledgeBaseLabel = getRegionLabel("knowledgeBaseSection", clientCode);

  const [selectedCategory, setSelectedCategory] =
    useState<KnowledgeBaseCategory | null>(null);
  const [isAddContentDrawerOpen, setIsAddContentDrawerOpen] = useState(false);

  const { data: knowledgeBaseCategories } = useGetKnowledgeBaseCategoriesQuery(
    {}
  );

  const categoriesData: KnowledgeBaseCategory[] = useMemo(() => {
    if (
      !Array.isArray(knowledgeBaseCategories) ||
      knowledgeBaseCategories?.length === 0
    )
      return [];
    return knowledgeBaseCategories?.map((cat: KnowledgeBaseCategoryAPI) => {
      const { icon, iconClassName } = getCategoryIcon(cat?.category_key);
      return {
        id: cat?.category_key,
        title: cat?.category_name,
        description: cat?.description,
        articleCount: cat?.count_of_documents,
        icon,
        iconClassName,
      };
    });
  }, [knowledgeBaseCategories]);

  const isFileManagementView = searchParams.get("view") === "files";

  const handleOpenFileManagement = () => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("view", "files");
      return next;
    });
  };

  if (isFileManagementView) {
    return <FileManagement />;
  }

  if (selectedCategory) {
    return (
      <CategoryDetailView
        topic={selectedCategory}
        onGoBack={() => setSelectedCategory(null)}
      />
    );
  }

  return (
    <div className="flex flex-col p-4 gap-4.5">
      <div className="flex items-center gap-3.5">
        <Button
          innerText="Go Back"
          iconLeft={true}
          Icon={RightArrowIcon}
          buttonContainerClass="w-fit"
          innerTextClass="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk leading-normal pb-[2px]"
          iconClass="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk rotate-180"
          onClick={() => navigate("/dashboard/crm/helpdesk/all-tickets")}
          type="button"
        />
        <div className="h-4 w-px bg-border-gray dark:bg-border-gray-dk" />
        <Button
          Icon={AddIcon}
          iconLeft={true}
          iconClass="w-4 h-4 text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk"
          innerText="Upload Document"
          onClick={() => setIsAddContentDrawerOpen(true)}
          buttonContainerClass="hover:bg-verba-blue-hover dark:hover:bg-verba-blue-hover-dk border border-verba-blue dark:border-verba-blue-dk bg-verba-blue dark:bg-verba-blue-dk w-fit font-semibold py-1.5 px-4 rounded-lg"
          innerTextClass="text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk text-md font-semibold text-nowrap"
        />
        <Button
          innerText="Files & Folders"
          onClick={handleOpenFileManagement}
          buttonContainerClass="w-fit font-semibold py-1.5 px-4 rounded-lg border border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
          innerTextClass="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk text-nowrap"
        />
      </div>
      <div className="flex flex-col items-center w-full px-6 py-[18px] rounded-lg border border-border-gray dark:border-border-gray-dk bg-gradient-ai-card dark:bg-gradient-ai-card-dk overflow-clip">
        <div className="flex items-center w-full">
          <div className="flex flex-col gap-4 flex-1 min-w-0">
            <div className="flex flex-col gap-2">
              <p className="text-2xl font-medium text-heading-text dark:text-heading-text-dk leading-none">
                {knowledgeBaseLabel}
              </p>
              <p className="text-md font-normal text-dark-gray dark:text-dark-gray-dk leading-normal">
                Find guides, tutorials, and answers to common questions. Search
                by category or use the search bar below or ask VerbaFlo's AI
                Assistant VerbaIQ
              </p>
            </div>

            <div className="flex flex-col gap-4 items-start">
              {/* <div className="relative w-[433px] h-[44px] p-[2px]">
                <div
                  className="absolute inset-0 rounded-[8px]"
                  style={{
                    background:
                      "linear-gradient(90deg, #c6bbff 0%, #285bd5 23.2%, #78dfff 51.4%, #ffb6b6 76%, #c6bbff 100%)",
                    boxShadow: "2.5px 5px 25px 0px rgba(198, 187, 255, 0.4)",
                  }}
                />
                <div className="relative flex items-center justify-between bg-pure-white dark:bg-pure-white-dk rounded-[8px] px-2 py-2 h-full">
                  <div className="flex-1 flex items-center h-5 pl-2">
                    <input
                      type="text"
                      placeholder="Search guides"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-full bg-transparent outline-none border-none text-md font-normal text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk placeholder:font-normal placeholder:text-md"
                    />
                  </div>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 rounded-[6px] shrink-0"
                    aria-label="Search"
                  >
                    <SearchIcon className="w-[15px] h-[15px] text-gray-placeholder dark:text-gray-placeholder-dk" />
                  </button>
                </div>
              </div> */}

              {/* <Button
                type="button"
                innerText="Ask VerbaIQ"
                iconLeft={true}
                Icon={VfCopilotIcon}
                iconClass="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk"
                innerTextClass="text-md font-medium text-heading-text dark:text-heading-text-dk leading-normal pb-[2px]"
                buttonContainerClass="px-2 py-[4px] border border-border-gray dark:border-border-gray-dk rounded-[6px] hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors"
              /> */}
            </div>
          </div>
        </div>
      </div>

      {categoriesData && categoriesData?.length > 0 && (
        <div className="flex flex-col gap-3 mt-[10px]">
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Browse by Category
          </h3>
          <div className="flex flex-wrap gap-4 items-start">
            {categoriesData?.map((topic) => (
              <CategoryCard
                key={topic?.id}
                topic={topic}
                onClick={setSelectedCategory}
              />
            ))}
          </div>
        </div>
      )}
      <ManageDocumentsTable categoriesData={categoriesData} />
      <AddContentDrawer
        open={isAddContentDrawerOpen}
        onClose={() => setIsAddContentDrawerOpen(false)}
        categories={categoriesData?.map((t) => ({
          id: t?.id,
          title: t?.title,
          icon: t?.icon,
          iconClassName: t?.iconClassName,
        }))}
      />
    </div>
  );
};

export default KnowledgeBase;
